import { noop } from 'lodash'
import React from 'react'

export type TLanguageContext = {
  value?: string
  onChange: (val?: string) => void
  languages?: string[]
}

export const LanguageContext = React.createContext<TLanguageContext>({
  value: 'de',
  onChange: noop,
  languages: ['de'],
})
